import { z } from "zod";

/** Blue-green deploys' shared words (M6 round five, task 4; brief "The blue-green Compose"; review B9, S9, S10): the two colours a
 *  process may serve as, the readiness answer Caddy probes (from memory, never from the database), the close code a draining colour
 *  sends its sockets (1012, "service restart": the client reconnects at once and reaches the other colour) and the web's one
 *  reconnect rule. */
export const SERVING_COLOURS = ["blue", "green"] as const;
export type ServingColour = (typeof SERVING_COLOURS)[number];
export const ReadySchema = z.object({ ready: z.boolean(), serving: z.enum(SERVING_COLOURS).nullable() }).strict();
export type Ready = z.infer<typeof ReadySchema>;
export const LIVE_RESTART_CODE = 1012;
/** the forum sync round (2026-11-02, finding 20): the server closes a socket with 4401 when its session ended (a browser never sees a refused
 *  upgrade's 401, only 1006); the app never reconnects after it and runs its signed-out check instead */
export const LIVE_SIGNED_OUT_CODE = 4401;
/** how long a closed socket waits before it reconnects: never after 4403 (no longer a member) or 4401 (signed out); at once after a restart's 1012 on the
 *  first try (another colour is ready); else the backoff live.ts always had, 500 ms doubling up to ten seconds (a 1012 whose immediate
 *  retry failed backs off like any other) */
export function liveReconnectDelay(code: number, attempt: number): number | null {
  if (code === 4403 || code === LIVE_SIGNED_OUT_CODE) return null;
  if (code === LIVE_RESTART_CODE && attempt === 0) return 0;
  return Math.min(10_000, 500 * 2 ** attempt);
}
